import Calendar from '@/entities/Calendar'
import Address from '@/entities/Address'
import { CALENDAR_TYPES } from '@/views/constants'

/*
  main display information for calendar
  calculating 2 times
    1. inside Calendar entity constructor
    2. after borrowed data collecting as one of last steps of calendarDataProcessor
 */
export default class CalendarDisplayInfo {
  constructor (calendar = new Calendar(), options) {
    this.practiceLogoMedia = options?.practice?.media?.PRACTICE_LOGO?.[0] ?? null

    // original ar borrowed providers (if availability_as = "other calendar")
    this.displayProviders = this.getDisplayProviders(calendar)
    // always original locations (event with availability_as = "other calendar" )
    this.displayLocations = this.getDisplayLocations(calendar)
    // image of currently display provider or practice logo
    this.image = this.getImageUrl(this.displayProviders.current?.media, this.practiceLogoMedia, calendar.settings.communication.showAsPractice, calendar.type)
    // name of currently  display provider
    this.providerName = this.displayProviders?.current?.name || null
    // name of currently  display location(actually it's always original location)
    this.locationName = this.displayLocations?.current?.internalName || null
    // address object of currently  display location(actually it's always original location)
    this.address = this.displayLocations?.current ? new Address(this.displayLocations.current, this.getIsMultipleLocationFlag(calendar.type, this.displayLocations.list)) : null
    /*
     calendar name
      provider/provider_location calendars use providerName or practice name is availability_as = "practice"
      location calendars use location name,
      practice calendar use name of practice
     */
    this.name = this.getCalendarName(this.providerName, this.locationName, options?.practice, calendar.type, calendar?.settings?.communication.showAsPractice)
    // specialty name of original provider
    this.specialty = this.getSpecialty(calendar?.originalProviders?.current)
    /*
     phoneFormatted, during calendar creating main location phone used
     after location info for exec calendar, updates with calendar location phone number(if it exist)
     */
    this.phoneFormatted = options?.appt_phone_formatted || ''
    // same as phoneFormatted
    this.phone = options?.appt_phone || ''
    //  label to show in the widget header (getter gets label from calendar with lowest id)
    this.label = options?.calendar_label || ''
    // footer text(html) for step B and C
    this.footerText = options?.calendar_text || ''
  }

  getDisplayProviders (calendar) {
    if ([CALENDAR_TYPES.PROVIDER_LOCATION_TYPE, CALENDAR_TYPES.PROVIDER_TYPE].includes(calendar.type) && calendar?.settings?.communication?.availabilityCalendarId) {
      return calendar.borrowedProviders
    } else {
      return calendar.originalProviders
    }
  }

  getDisplayLocations (calendar) {
    return calendar.originalLocations
  }

  /*
  * return calendar img or url or empty string
  * - for practice/location calendar it will return practice logo url(if exist)
  * - for provider/provider_location calendars
  *   - with "availability_as = practice" return practice logo url(if exist)
  *   - with "availability_as = self" return provider image irl(if exist)
  * */
  getImageUrl (providerImage, practiceLogo, showAsPractice, calendarType = CALENDAR_TYPES.PRACTICE_TYPE) {
    const usePracticeImage = [CALENDAR_TYPES.PRACTICE_TYPE, CALENDAR_TYPES.LOCATION_TYPE].includes(calendarType) || showAsPractice
    // calendarTypes Provider & Provider_Location utilize url for img src
    if (!usePracticeImage) {
      return providerImage?.full_image_url || ''
    }

    const mediaId = practiceLogo?.id
    const fileExtension = practiceLogo?.file_extension

    // if there is no image - return empty string as src
    if (!practiceLogo || !(mediaId && fileExtension)) {
      return ''
    }
    return `https://sa1s3optim.patientpop.com/fit-in/180x180/assets/images/provider/photos/${process.env.VUE_APP_PROVIDER_IMG_URL_FOLDER}${mediaId}.${fileExtension}`
  }

  getIsMultipleLocationFlag (type, allPracticeLocations) {
    return allPracticeLocations.length > 1 && [CALENDAR_TYPES.PROVIDER_TYPE, CALENDAR_TYPES.PRACTICE_TYPE].includes(type)
  }

  getCalendarName (providerName, locationName, practice, type, showAsPractice = false) {
    if (CALENDAR_TYPES.PRACTICE_TYPE === type || showAsPractice) {
      return practice?.name || ''
    } else if ([CALENDAR_TYPES.PROVIDER_TYPE, CALENDAR_TYPES.PROVIDER_LOCATION_TYPE].includes(type)) {
      return providerName || ''
    } else if (CALENDAR_TYPES.LOCATION_TYPE === type) {
      return locationName || ''
    }
  }

  getSpecialty (provider) {
    if (!provider) {
      return null
    }

    if (provider.siteSpecialties && provider.siteSpecialties.length > 0) {
      let siteSpecialty = provider.siteSpecialties.find(specialty => specialty.main === 1)
      if (!siteSpecialty) {
        siteSpecialty = provider.siteSpecialties[0]
      }

      return siteSpecialty.specialty.specialty
    }
    return null
  }
}
